// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { ApiKeyAuth, OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let SurveyV3Api = class SurveyV3Api {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'ApiKey': new ApiKeyAuth('header', 'x-apikey'),
            'trialcard-poc.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'trialcard-test.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Bearer': new ApiKeyAuth('header', 'Authorization'),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @summary Get a list of Question and chosen Answers related to a list of Survey Session IDs.
     * @param surveyIdListRequestModel Survey Session IDs
     */
    async fullSurveySessionByIdsCreate0(surveyIdListRequestModel) {
        const _url_ = '/survey/v3/FullSurveySessionByIds';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'surveyIdListRequestModel' is not null or undefined
        if (surveyIdListRequestModel === null || surveyIdListRequestModel === undefined) {
            throw new Error('Required parameter surveyIdListRequestModel was null or undefined when calling fullSurveySessionByIdsCreate0.');
        }
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(surveyIdListRequestModel, "SurveyIdListRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SurveySessionValueReadModels");
        }
        return response;
    }
    /**
     *
     * @summary Creates a new full survey session including questions and answers
     * @param surveyFullSurveySessionValuesModel The session values to create
     */
    async fullSurveySessionCreate0(surveyFullSurveySessionValuesModel) {
        const _url_ = '/survey/v3/FullSurveySession';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'surveyFullSurveySessionValuesModel' is not null or undefined
        if (surveyFullSurveySessionValuesModel === null || surveyFullSurveySessionValuesModel === undefined) {
            throw new Error('Required parameter surveyFullSurveySessionValuesModel was null or undefined when calling fullSurveySessionCreate0.');
        }
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(surveyFullSurveySessionValuesModel, "SurveyFullSurveySessionValuesModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SurveyResponseModel");
        }
        return response;
    }
    /**
     *
     * @summary Gets a full survey session including questions and answers
     * @param id Survey Session ID
     */
    async fullSurveySessionGet1(id) {
        const _url_ = '/survey/v3/FullSurveySession/{id}'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling fullSurveySessionGet1.');
        }
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SurveySessionValueReadModels");
        }
        return response;
    }
    /**
     *
     * @summary Create a session response record.
     * @param surveySaveQuestionResultRequestModel
     */
    async sessionValueCreate0(surveySaveQuestionResultRequestModel) {
        const _url_ = '/survey/v3/SessionValue';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'surveySaveQuestionResultRequestModel' is not null or undefined
        if (surveySaveQuestionResultRequestModel === null || surveySaveQuestionResultRequestModel === undefined) {
            throw new Error('Required parameter surveySaveQuestionResultRequestModel was null or undefined when calling sessionValueCreate0.');
        }
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(surveySaveQuestionResultRequestModel, "SurveySaveQuestionResultRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SurveySaveQuestionResultModelResponse");
        }
        return response;
    }
    /**
     *
     * @summary Create a new Survey Session definition.
     * @param surveyStartSessionRequestModel StartSessionRequestModel object
     */
    async surveySessionCreate0(surveyStartSessionRequestModel) {
        const _url_ = '/survey/v3/SurveySession';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'surveyStartSessionRequestModel' is not null or undefined
        if (surveyStartSessionRequestModel === null || surveyStartSessionRequestModel === undefined) {
            throw new Error('Required parameter surveyStartSessionRequestModel was null or undefined when calling surveySessionCreate0.');
        }
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(surveyStartSessionRequestModel, "SurveyStartSessionRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SurveyStartSessionModelResponse");
        }
        return response;
    }
};
SurveyV3Api = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], SurveyV3Api);
export { SurveyV3Api };
//# sourceMappingURL=surveyV3Api.js.map